"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _ = _interopRequireWildcard(require("./4.3.0"));
var _LocaleContext = require("../locales/LocaleContext");
var _default2 = _interopRequireDefault(require("../locales/default"));
var _warning = _interopRequireDefault(require("./warning"));
var _omit = _interopRequireDefault(require("omit.js"));
var _inputHOC = _interopRequireDefault(require("../Form/inputHOC"));
var _ykbUtils = require("ykb-utils");
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledTreeSelect = require("./StyledTreeSelect");
var _excluded = ["prefixCls", "size", "bordered", "className", "treeCheckable", "multiple", "listHeight", "listItemHeight", "notFoundContent", "switcherIcon", "treeLine", "getPopupContainer", "dropdownClassName", "treeIcon", "transitionName", "choiceTransitionName", "showSearch"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var InternalTreeSelect = function InternalTreeSelect(_ref, ref) {
  var prefixCls = _ref.prefixCls,
    customizeSize = _ref.size,
    _ref$bordered = _ref.bordered,
    bordered = _ref$bordered === void 0 ? true : _ref$bordered,
    className = _ref.className,
    treeCheckable = _ref.treeCheckable,
    multiple = _ref.multiple,
    _ref$listHeight = _ref.listHeight,
    listHeight = _ref$listHeight === void 0 ? 256 : _ref$listHeight,
    _ref$listItemHeight = _ref.listItemHeight,
    listItemHeight = _ref$listItemHeight === void 0 ? 26 : _ref$listItemHeight,
    notFoundContent = _ref.notFoundContent,
    switcherIcon = _ref.switcherIcon,
    treeLine = _ref.treeLine,
    getPopupContainer = _ref.getPopupContainer,
    dropdownClassName = _ref.dropdownClassName,
    _ref$treeIcon = _ref.treeIcon,
    treeIcon = _ref$treeIcon === void 0 ? false : _ref$treeIcon,
    _ref$transitionName = _ref.transitionName,
    transitionName = _ref$transitionName === void 0 ? 'slide-up' : _ref$transitionName,
    _ref$choiceTransition = _ref.choiceTransitionName,
    choiceTransitionName = _ref$choiceTransition === void 0 ? '' : _ref$choiceTransition,
    showSearch = _ref.showSearch,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  (0, _warning.default)(multiple !== false || !treeCheckable, 'TreeSelect', '`multiple` will alway be `true` when `treeCheckable` is true');
  var isMultiple = multiple;

  // ==================== Render =====================
  var selectProps = (0, _omit.default)(props, ['suffixIcon', 'itemIcon', 'removeIcon', 'clearIcon', 'switcherIcon']);
  return /*#__PURE__*/_react.default.createElement(_LocaleContext.LocaleReceiver, {
    componentName: "TreeSelect",
    defaultLocale: _default2.default.TreeSelect
  }, function (localeCode, locale) {
    return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
      return /*#__PURE__*/_react.default.createElement(_StyledTreeSelect.StyledTreeSelectContainer, {
        prefixCls: prefixCls,
        theme: theme
      }, function (prefix) {
        return /*#__PURE__*/_react.default.createElement(_.default, (0, _extends2.default)({}, selectProps, {
          showSearch: showSearch,
          multiple: isMultiple,
          ref: ref,
          prefixCls: prefix,
          className: 'semihclassName',
          listHeight: listHeight,
          listItemHeight: listItemHeight,
          treeCheckable: treeCheckable ? /*#__PURE__*/_react.default.createElement("span", {
            className: "".concat(prefixCls, "-tree-checkbox-inner")
          }) : treeCheckable
          // removeIcon={<Icon name="close-alt" />}
          ,
          removeIcon: undefined
          // clearIcon={<Icon name="close-alt" />}
          ,
          clearIcon: undefined
          // switcherIcon={null}
          // switcherIcon={<Icon type="user-alt" />}
          ,
          switcherIcon: undefined,
          treeIcon: treeIcon,
          notFoundContent: notFoundContent ? notFoundContent : locale.notFoundContent,
          getPopupContainer: _ykbUtils.containerChecker,
          treeMotion: null,
          theme: theme
        }));
      });
    });
  });
};
var TreeSelectRef = /*#__PURE__*/_react.default.forwardRef(InternalTreeSelect);
TreeSelectRef.displayName = 'TreeSelect';
var TreeSelect = (0, _inputHOC.default)(TreeSelectRef);
TreeSelect.TreeNode = _.TreeNode;
TreeSelect.SHOW_ALL = _.SHOW_ALL;
TreeSelect.SHOW_PARENT = _.SHOW_PARENT;
TreeSelect.SHOW_CHILD = _.SHOW_CHILD;
var _default = exports.default = TreeSelect;